
export default function Features() {
  const features = [
    {
      icon: 'ri-shield-check-line',
      title: 'Enhanced Security',
      description: 'Advanced encryption and security protocols to protect your data and privacy on all iOS devices.',
      color: 'bg-purple-100 text-purple-600'
    },
    {
      icon: 'ri-speed-line',
      title: 'Optimized Performance',
      description: 'Lightweight applications designed for maximum efficiency without compromising device performance.',
      color: 'bg-blue-100 text-blue-600'
    },
    {
      icon: 'ri-user-smile-line',
      title: 'Intuitive Interface',
      description: 'Clean, user-friendly designs that make complex features accessible to everyone.',
      color: 'bg-green-100 text-green-600'
    },
    {
      icon: 'ri-refresh-line',
      title: 'Regular Updates',
      description: 'Continuous improvements and new features to keep your apps current with iOS standards.',
      color: 'bg-orange-100 text-orange-600'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: '24/7 Support',
      description: 'Dedicated support team ready to assist you whenever you need help with our applications.',
      color: 'bg-pink-100 text-pink-600'
    },
    {
      icon: 'ri-lock-line',
      title: 'Privacy Focused',
      description: 'Your data stays yours. We prioritize user privacy in every aspect of our applications.',
      color: 'bg-cyan-100 text-cyan-600'
    }
  ];

  return (
    <section id="features" className="py-24 bg-amber-50/30">
      <div className="max-w-6xl mx-auto px-8 lg:px-16">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-gray-900 mb-6">
            Why Choose Our Applications
          </h2>
          <p className="text-xl text-gray-600">
            Designed to enhance your iOS experience and improve device security
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-lg transition-shadow duration-300"
            >
              <div className={`w-20 h-20 rounded-full ${feature.color} flex items-center justify-center mb-6`}>
                <i className={`${feature.icon} text-3xl`}></i>
              </div>
              <h3 className="text-2xl font-semibold text-gray-900 mb-4">
                {feature.title}
              </h3>
              <p className="text-base text-gray-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
